import type {SVGProps} from 'react';

import Icon from './Icon';

const BackArrowIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <Icon width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
            <path
                d='M15 4L7 12L15 20'
                className='stroke-primary dark:stroke-secondary'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </Icon>
    );
};

export default BackArrowIcon;
